export default __webpack_public_path__ + "static/logo-68ec5196797a8c9d64bd99558d057620.png";